import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import API from "../api";

import compassIcon from "../assets/icons/compass.png";
import membresIcon from "../assets/icons/membres.png";
import plancheIcon from "../assets/icons/planche1.png";
import logeIcon from "../assets/icons/local.png";
import agendaIcon from "../assets/icons/calendar.png";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const [unreadTotal, setUnreadTotal] = useState(0);

  const isActive = (path) => location.pathname === path;

  const vibrate = () => {
    if (navigator.vibrate) navigator.vibrate(25);
  };

  const fetchUnread = async () => {
    try {
      const res = await API.get("/conversations");

      const total = res.data.reduce(
        (sum, conv) => sum + Number(conv.unread_count || 0),
        0
      );

      setUnreadTotal(total);
    } catch (err) {
      console.error("Erreur unread navbar:", err);
    }
  };

  useEffect(() => {
    fetchUnread();
    const interval = setInterval(fetchUnread, 5000);
    return () => clearInterval(interval);
  }, []);

  const go = (path) => {
    vibrate();
    setOpen(false);
    navigate(path);
  };

  const toggleMenu = () => {
    vibrate();
    setOpen(!open);
  };

  return (
    <>
      <style>
        {`
          @keyframes pulseGlow {
            0% {
              box-shadow: 0 0 14px rgba(214,180,106,0.45),
                          0 0 28px rgba(214,180,106,0.20);
            }
            50% {
              box-shadow: 0 0 24px rgba(214,180,106,0.85),
                          0 0 48px rgba(214,180,106,0.38);
            }
            100% {
              box-shadow: 0 0 14px rgba(214,180,106,0.45),
                          0 0 28px rgba(214,180,106,0.20);
            }
          }

          @keyframes menuUp {
            from {
              opacity: 0;
              transform: translateY(20px) scale(0.95);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          .center-pulse {
            animation: pulseGlow 2.2s infinite ease-in-out;
          }

          .quick-menu-animate {
            animation: menuUp 0.22s ease-out;
          }

          .overlay-animate {
            animation: fadeIn 0.18s ease-out;
          }

          .nav-press:active {
            transform: scale(0.92);
          }

          .center-press:active {
            transform: translateY(-22px) scale(0.92);
          }
        `}
      </style>

      {open && (
        <div
          className="overlay-animate"
          style={styles.overlay}
          onClick={() => setOpen(false)}
        >
          <div
            className="quick-menu-animate"
            style={styles.quickMenu}
            onClick={(e) => e.stopPropagation()}
          >
            <button style={styles.quickBtn} onClick={() => go("/members")}>
              <span
                style={{
                  ...styles.quickIconBox,
                  backgroundImage: `url(${membresIcon})`,
                }}
              />
              <span>Membres</span>
            </button>

            <button style={styles.quickBtn} onClick={() => go("/planches")}>
              <span
                style={{
                  ...styles.quickIconBox,
                  backgroundImage: `url(${plancheIcon})`,
                }}
              />
              <span>Planches</span>
            </button>

            <button style={styles.quickBtn} onClick={() => go("/lodges")}>
              <span
                style={{
                  ...styles.quickIconBox,
                  backgroundImage: `url(${logeIcon})`,
                }}
              />
              <span>Loges</span>
            </button>

            <button style={styles.quickBtn} onClick={() => go("/events")}>
              <span
                style={{
                  ...styles.quickIconBox,
                  backgroundImage: `url(${agendaIcon})`,
                }}
              />
              <span>Agenda</span>
            </button>
          </div>
        </div>
      )}

      <nav style={styles.navbar}>
        <button
          className="nav-press"
          style={styles.item}
          onClick={() => go("/home")}
        >
          <span style={isActive("/home") ? styles.activeIcon : styles.icon}>
            ⌂
          </span>
          <span style={isActive("/home") ? styles.activeText : styles.text}>
            Accueil
          </span>
        </button>

        <button
          className="nav-press"
          style={styles.item}
          onClick={() => go("/messages")}
        >
          <span style={styles.iconWrap}>
            <span style={isActive("/messages") ? styles.activeIcon : styles.icon}>
              ◌
            </span>

            {unreadTotal > 0 && (
              <span style={styles.navBadge}>
                {unreadTotal > 99 ? "99+" : unreadTotal}
              </span>
            )}
          </span>

          <span style={isActive("/messages") ? styles.activeText : styles.text}>
            Messages
          </span>
        </button>

        <button
          className="center-pulse center-press"
          style={styles.centerBtn}
          onClick={toggleMenu}
        >
          <img src={compassIcon} alt="Menu" style={styles.centerIcon} />
        </button>

        <button
          className="nav-press"
          style={styles.item}
          onClick={() => go("/music")}
        >
          <span style={isActive("/music") ? styles.activeIcon : styles.icon}>
            ♪
          </span>
          <span style={isActive("/music") ? styles.activeText : styles.text}>
            Musique
          </span>
        </button>

        <button
          className="nav-press"
          style={styles.item}
          onClick={() => go("/profile")}
        >
          <span style={isActive("/profile") ? styles.activeIcon : styles.icon}>
            ♙
          </span>
          <span style={isActive("/profile") ? styles.activeText : styles.text}>
            Profil
          </span>
        </button>
      </nav>
    </>
  );
}

const styles = {
  navbar: {
    position: "fixed",
    left: 16,
    right: 16,
    bottom: 0,
    paddingBottom: "env(safe-area-inset-bottom, 16px)",
    height: 88,
    borderTopLeftRadius: 40,
    borderTopRightRadius: 40,
    background: "rgba(3,6,12,0.96)",
    border: "1px solid rgba(214,180,106,0.28)",
    boxShadow: "0 -10px 40px rgba(0,0,0,0.6)",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 80px 1fr 1fr",
    alignItems: "center",
    justifyItems: "center",
    zIndex: 10000,
    backdropFilter: "blur(16px)",
  },

  item: {
    width: "100%",
    height: "100%",
    paddingTop: 6,
    paddingBottom: 12,
    border: "none",
    background: "transparent",
    color: "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 5,
    cursor: "pointer",
    transition: "0.15s ease",
  },

  iconWrap: {
    position: "relative",
    display: "inline-flex",
  },

  icon: {
    fontSize: 25,
    color: "rgba(255,255,255,0.55)",
  },

  activeIcon: {
    fontSize: 27,
    color: "#d6b46a",
    textShadow: "0 0 12px rgba(214,180,106,0.65)",
  },

  text: {
    fontSize: 11,
    fontWeight: 800,
    color: "rgba(255,255,255,0.62)",
    lineHeight: 1,
  },

  activeText: {
    fontSize: 11,
    fontWeight: 900,
    color: "#d6b46a",
    borderBottom: "2px solid #d6b46a",
    paddingBottom: 3,
    lineHeight: 1,
  },

  navBadge: {
    position: "absolute",
    top: -8,
    right: -12,
    minWidth: 18,
    height: 18,
    padding: "0 5px",
    borderRadius: 999,
    background: "#d6b46a",
    color: "#111",
    fontSize: 10,
    fontWeight: 900,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 10px rgba(214,180,106,0.8)",
  },

  centerBtn: {
    width: 66,
    height: 66,
    borderRadius: "50%",
    border: "2px solid rgba(214,180,106,0.95)",
    background: "rgba(3,6,12,0.96)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    transform: "translateY(-22px)",
    cursor: "pointer",
    overflow: "hidden",
    transition: "0.15s ease",
  },

  centerIcon: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 9998,
    background: "rgba(0,0,0,0.35)",
    backdropFilter: "blur(2px)",
  },

  quickMenu: {
    position: "fixed",
    left: 24,
    right: 24,
    bottom: 112,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    zIndex: 9999,
  },

  quickBtn: {
    minHeight: 74,
    padding: "10px",
    borderRadius: 18,
    border: "1px solid rgba(214,180,106,0.35)",
    background: "rgba(9,14,22,0.96)",
    color: "white",
    fontSize: 14,
    fontWeight: 900,
    boxShadow: "0 12px 28px rgba(0,0,0,0.35)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
  },

  quickIconBox: {
    width: 42,
    height: 42,
    flexShrink: 0,
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    filter: "drop-shadow(0 0 8px rgba(214,180,106,0.55))",
  },
};

export default Navbar;